import { generateKeys } from '../utils';
export const promocodeStatusTypes = generateKeys({
    active: {
        value: 1,
        label: 'Active',
    },
    inactive: {
        value: 0,
        label: 'Inactive',
    },
});
export const promocodeCategoryTypes = generateKeys({
    deposit: {
        value: 'deposit',
        label: 'Deposit',
    },
    onboard: {
        value: 'onboard',
        label: 'On Board',
    },
    instant: {
        value: 'instant',
        label: 'Instant',
    },
});
export const promocodeSingleTypes = generateKeys({
    non_single: {
        value: 0,
        label: 'Single',
        boolean: false,
    },
    single: {
        value: 1,
        label: 'Multiple',
        boolean: true,
    },
});
export const promocodeFtdTypes = generateKeys({
    optional: {
        value: 0,
        label: 'False',
        boolean: false,
    },
    required: {
        value: 1,
        label: 'True',
        boolean: true,
    },
});
export const promocodeMaxUses = generateKeys({
    infinite: {
        value: -1,
        label: 'Infinite',
    },
});
